import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    cart: JSON.parse(localStorage.getItem('cart')) || [],
    currentProduct: {},
    categories: [],
    products: [],
    pizzas: [],
    beverages: [],
    freeBeverages: [],
    streets: [],
    cities: [],
    locationCities: [],
    takeawayLocations: [],
    deliveryTimes: [],
    nightMode: JSON.parse(localStorage.getItem('nightmode')),

    locationCityId: JSON.parse(localStorage.getItem('locationCityId')),
    phone: '',
    address: '',
    // phone: '066 711 92 91',
    // address: 'м. Луцьк, вул. Липинського, 7',
  },
  mutations: {
    addToCart(state, product) {
      state.cart.push(product);
      state.cart = state.cart.sort((a, b) => {
        return a.priceWithoutAdditionals - b.priceWithoutAdditionals
      });
      localStorage.setItem('cart', JSON.stringify(state.cart));
    },

    removeFromCart(state, product) {
      let arr = state.cart.filter(obj => {
        return obj != product;
      });

      state.cart = arr;
      localStorage.setItem('cart', JSON.stringify(state.cart));
    },

    emptyCart(state) {
      state.cart = [];
      localStorage.setItem('cart', JSON.stringify(state.cart));
    },

    setCurrentProduct(state, product) {
      state.currentProduct = product;
    },
    
    setMode(state, mode) {
      state.nightMode = mode;
    },

    setLocationCityId(state, locationCityId) {
      state.locationCityId = locationCityId;
    },

    setPhone(state, phone) {
      state.phone = phone;
    },

    setAddress(state, address) {
      state.address = address;
    }
  },
  actions: {
    getCategories({ state }) {
      return new Promise((resolve, reject) => {
        if(state.categories.length) {
          resolve(state.categories);
          return;
        }
        axios.get(`${Vue.prototype.SERVER_URL}/api/${state.locationCityId}/categories`).then(response => {
          state.categories = response.data.categories;
          resolve(state.categories);
        }).catch(e => reject(e));
      });
    },

    getProducts({ state }) {
      return new Promise((resolve, reject) => {
        if(state.products.length) {
          resolve(state.products);
          return;
        }
        axios.get(`${Vue.prototype.SERVER_URL}/api/${state.locationCityId}/products`).then(response => {
          state.products = response.data.products;
          resolve(state.products);
        }).catch(e => reject(e));
      });
    },

    getPizzas({ state }) {
      return new Promise((resolve, reject) => {
        if(state.pizzas.length) {
          resolve(state.pizzas);
          return;
        }
        axios.get(`${Vue.prototype.SERVER_URL}/api/${state.locationCityId}/pizzas`).then(response => {
          state.pizzas = response.data;
          resolve(state.pizzas);
        }).catch(e => reject(e));
      });
    },

    getBeverages({ state }) {
      return new Promise((resolve, reject) => {
        if(state.beverages.length) {
          resolve(state.beverages);
          return;
        }
        axios.get(`${Vue.prototype.SERVER_URL}/api/${state.locationCityId}/beverages`).then(response => {
          state.beverages = response.data;
          resolve(state.beverages);
        }).catch(e => reject(e));
      });
    },

    getFreeBeverages({ state }) {
      return new Promise((resolve, reject) => {
        if(state.freeBeverages.length) {
          resolve(state.freeBeverages);
          return;
        }
        axios.get(`${Vue.prototype.SERVER_URL}/api/${state.locationCityId}/free-beverages`).then(response => {
          response.data.forEach(e => {
            e.freeBeverage = 1;
            e.additionaIngredients = [];
            e.priceWithoutAdditionals = e.price;
            e.quanity = 1;
            e.size = e.volume + ' ml';
          });

          state.freeBeverages = response.data;
          resolve(state.freeBeverages);
        }).catch(e => reject(e));
      });
    },

    getStreets({ state }) {
      return new Promise((resolve, reject) => {
        if(state.streets.length) {
          resolve(state.streets);
          return;
        }
        axios.get(`${Vue.prototype.SERVER_URL}/api/${state.locationCityId}/streets`).then(response => {
          state.streets = response.data;
          resolve(state.streets);
        }).catch(e => reject(e));
      });
    },

    getCities({ state }) {
      return new Promise((resolve, reject) => {
        if(state.cities.length) {
          resolve(state.cities);
          return;
        }
        axios.get(`${Vue.prototype.SERVER_URL}/api/${state.locationCityId}/cities`).then(response => {
          state.cities = response.data;
          resolve(state.cities);
        }).catch(e => reject(e));
      });
    },

    getLocationCities({ state }) {
      return new Promise((resolve, reject) => {
        if(state.locationCities.length) {
          resolve(state.locationCities);
          return;
        }
        axios.get(`${Vue.prototype.SERVER_URL}/api/location_cities?is_enabled_only=1`).then(response => {
          state.locationCities = response.data;
          resolve(state.locationCities);
        }).catch(e => reject(e));
      });
    },

    getTakeawayLocations({ state }) {
      return new Promise((resolve, reject) => {
        if(state.takeawayLocations.length) {
          resolve(state.takeawayLocations);
          return;
        }
        axios.get(`${Vue.prototype.SERVER_URL}/api/${state.locationCityId}/location_cities/takeaways`).then(response => {
          state.takeawayLocations = response.data;
          resolve(state.takeawayLocations);
        }).catch(e => reject(e));
      });
    },

    getDeliveryTimes({ state }) {
      return new Promise((resolve, reject) => {
        axios.get(`${Vue.prototype.SERVER_URL}/api/${state.locationCityId}/order/delivery-time`).then(response => {
          state.deliveryTimes = response.data;
          resolve(state.deliveryTimes);
        }).catch(e => reject(e));
      });
    }
  }
})
